import { render, staticRenderFns } from "./CompItemCalc.vue?vue&type=template&id=f130432a&scoped=true"
import script from "./CompItemCalc.vue?vue&type=script&lang=js"
export * from "./CompItemCalc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f130432a",
  null
  
)

export default component.exports